import {TableConfigBuilder} from '@common-module/table-config/table-config.builder';
import {StyleBuilder, TableConfig} from 'ngx-aur-mat-table';

import {NotificationStatus} from '@common-module/modelinterfaces/enums/notification-status';
import {NotificationWithNew} from '@common-module/modelinterfaces/notification-with-new.model';

export function createNotificationTableConfig(): TableConfig<NotificationWithNew> {
  return {
    trackBy: item => item.notification.id,
    columnsCfg: [
      {
        ...TableConfigBuilder.column.value(
          'read',
          '',
          item => item.notification.id,
        ),
        size: {
          ...TableConfigBuilder.column.size.fixedWidth('30px'),
          paddingLeft: '0',
          paddingRight: '0',
        },
      },
      {
        ...TableConfigBuilder.column.value(
          'unitName',
          '',
          item => item.notification.unit.name,
        ),
      },
      TableConfigBuilder.column.value(
        'message',
        '',
        item => item.notification.text,
      ),
      {
        ...TableConfigBuilder.column.value(
          'time',
          '',
          item => item.notification.startTime,
        ),
        size: {
          ...TableConfigBuilder.column.size.fixedWidth('52px'),
          paddingLeft: '0',
          paddingRight: '0',
        },
      },
    ],
    headerRowCfg: {
      styleCfg: {
        style: 'display: none;',
      },
    },
    bodyRowCfg: {
      clickCfg: TableConfigBuilder.row.click.enabled(),
      hoverCfg: {
        styleCfg: {
          style: StyleBuilder.Row.builder().background('var(--color-almost-white)'),
        },
      },
      styleCfg: {
        class: row => [
          'highlight-row',
          row.rowSrc.notification.status === NotificationStatus.ACTIVE ? 'active-notification' : '',
          row.rowSrc.isNew ? 'new-notification' : '',
        ].filter(Boolean).join(' '),
      },
    },
  };
}
